import Api from "./Api";

export default {
  getThemes(companyId) {
    return Api().get(`/themes/${companyId}`);
  },
  getThemeById(payload) {
    return Api().get(`/themes/${payload.company_id}/${payload.id}`);
  },
  addTheme(payload) {
    return Api().post(`/themes/${payload.company_id}`, payload);
  },
  editTheme(payload) {
    return Api().put(
      `/themes/${payload.company_id}/${payload.id}`,
      payload.data
    );
  },
  deleteTheme(payload) {
    return Api().delete(`/themes/${payload.company_id}/${payload.id}`);
  },
  duplicateTheme(payload) {
    return Api().post(
      `/themes/${payload.company_id}/${payload.theme_id}/duplicate`,
      payload.data
    );
  },
  assignTheme(payload) {
    return Api().post(
      `/assignments/${payload.company_id}/bulk-assign`,
      payload.data
    );
  },
  getThemeAssignmentsGrid(payload) {
    return Api().get(
      `/assignments/${payload.company_id}/theme/${payload.theme_id}`
    );
  },
  editThemeAssignment(payload) {
    return Api().put(
      `/assignments/${payload.company_id}/${payload.id}`,
      payload.data
    );
  },
  activateThemeAssignment(payload) {
    return Api().post(
      `/assignments/${payload.company_id}/status`,
      payload.data
    );
  },
  deleteThemeAssignment(payload) {
    return Api().delete(`/assignments/${payload.company_id}/${payload.id}`);
  },
  restoreDefaultTheme(payload) {
    return Api().get(`/themes/${payload.company_id}/restore-default/${payload.type}`);
  },
};
